<script>
import checkbox from "@/components/fields/List.vue";
import radio from "@/components/fields/Radio.vue";
import Range from "@/components/fields/Range.vue";
import TextField from "@/components/fields/TextField.vue";
import NumberField from "@/components/fields/NumberField.vue";
import Multiselect from "@/components/fields/Multiselect.vue";
import { GET, POST } from "@/shared/api";
import EmptyArea from "@/views/combinationv2/components/EmptyArea.vue";
import EyeIcon from "../../assets/icons/EyeIcon.vue";

export default {
  name: "combinationForm",
  props: {
    properties: [],
    product_title: "",
    product_code: null,
    selected_product: {},
  },
  data() {
    return {
      specification: [],
      choosenProduct: null,
      formState: {
        code_system: "",
        name: "",
        unit_name: "",
        mxik_code: "",
        name_en: "",
        name_uz: "",
        tnvd_code: "",
      },
      codeTracker: {
        product_code: this.product_code,
        container: {},
        new_code: null,
      },
    };
  },
  components: {
    EmptyArea,
    checkbox,
    radio,
    Range,
    TextField,
    NumberField,
    Multiselect,
  },

  watch: {
    properties(new_value) {
      if (Array.isArray(new_value)) {
        let fields = [...new_value];
        fields = fields.filter((el) => el.title !== null);
        this.choosenProduct = new_value;
        this.makeSpecification();
      }
    },
    product_title() {
      this.codeTracker.product_code = this.product_code;
      this.codeTracker.container = {};
      this.codeTracker.new_code = null;
      this.specification = [];
      this.formState = {
        code_system: "",
        name: "",
        unit_name: "",
        mxik_code: "",
        name_en: "",
        name_uz: "",
        tnvd_code: "",
      };
      this.$refs.form.reset();
    },
  },
  methods: {
    submit() {
      let ready = true;
      this.choosenProduct.forEach((el) => {
        this.update(
          {
            title: el.title,
            value: el.value,
            model: el,
          },
          false
        );
      });

      this.choosenProduct.forEach((el) => {
        if (el.isRequired && el.invalid) {
          ready = false;
        }
      });

      if (ready) {
        this.postCombination();
      }
    },

    postCombination() {
      this.$refs.form.validate().then((success) => {
        if (success) {
          POST(
            {
              ...this.formState,
              product_id: this.selected_product.id,
              new_code: this.codeTracker.new_code,
            },
            "/combination",
            this,
            true
          ).then((response) => {
            this.clearFormState();
            this.$refs.form.reset();
          });
        }
      });
    },
    clearFormState() {
      this.formState = {
        code_system: "",
        name: "",
        unit_name: "",
        mxik_code: "",
        name_en: "",
        name_uz: "",
        tnvd_code: "",
      };
      this.codeTracker.product_code = this.product_code;
      this.codeTracker.container = {};
      this.codeTracker.new_code = null;
      this.specification = [];
      this.$emit("formClear");
    },

    getValues(params = {}, model = {}, value = []) {
      GET(params, `/product/query/${model.id}`, this, false)
        .then((response) => {
          const matches = response.filter((item) => value.includes(item.value));
          if (!this.codeTracker.container[model.title]) {
            this.$set(this.codeTracker.container, model.title, {});
          }

          if (!value.length) {
            delete this.codeTracker.container[model.title];
          } else {
            this.codeTracker.container[model.title].field_num = model.index + 1;
            this.codeTracker.container[model.title].value_nums = matches
              .map((item) => Number(item.index) + 1)
              .sort((a, b) => a - b);
          }

          const sortedEntries = Object.values(this.codeTracker.container).sort(
            (a, b) => a.field_num - b.field_num
          );

          const parts = sortedEntries.map((entry) => {
            return entry.field_num + ":" + entry.value_nums.join(":");
          });

          const result = parts.join("/");
          this.codeTracker.new_code = this.product_code + "/" + result;

          const idx = this.choosenProduct.findIndex(
            (col) => col.id === model.id
          );
          this.$set(this.choosenProduct[idx], "value", value);
        })
        .catch((err) => {
          console.error("GET error:", err);
        });
    },
    update({ title, value, model = null }, make_request = true) {
      if (typeof value === "undefined") {
        return;
      }
      if (typeof title === "undefined") {
        return;
      }
      if (model !== null) {
        let index = null;
        this.specification.forEach((f, i) => {
          if (model.id === f.id) {
            index = i;
          }
        });
        if (index !== null) {
          if (make_request) {
            this.getValues({ mode: "values" }, model, value);
          }
          this.$set(this.specification, index, this.updateField(model, value));
        }
      }
    },
    updateField(field, value) {
      let f = field;
      if (["number", "text"].includes(field.inputType)) {
        f.value = value;

        if (
          field.isRequired &&
          (typeof field.value === "undefined" || field.value == null)
        ) {
          f.invalid = true;
        } else {
          f.invalid = false;
        }
      } else if (
        ["boolean", "multiselect", "checkbox"].includes(field.inputType)
      ) {
        f.value = value;

        if (
          field.isRequired &&
          (typeof field.value === "undefined" ||
            field.value == null ||
            field.value.length === 0)
        ) {
          f.invalid = true;
        } else {
          f.invalid = false;
        }
      } else if (field.inputType === "radio") {
        if (
          field.isRequired &&
          (typeof value === "undefined" || value == null)
        ) {
          f.invalid = true;
        } else {
          f.value = value;
          f.invalid = false;
        }
      } else if (field.inputType === "range") {
        if (
          Array.isArray(value) &&
          typeof value !== "undefined" &&
          value !== null
        ) {
          value.forEach((va) => {
            f = this.handleRangeUpdate(field, va);
          });
        } else {
          f = this.handleRangeUpdate(field, value);
        }
      }

      return f;
    },
    makeSpecification() {
      this.specification = this.choosenProduct;
      this.specification.map((el) => {
        const newEl = el;
        if (newEl.inputType === "list" && !newEl.value) {
          newEl.value = [];
        } else if (newEl.inputType === "range" && !newEl.value) {
          newEl.value = {};
        } else if (!newEl.value) {
          newEl.value = null;
        }
        return newEl;
      });
    },
    renderView(inputName) {
      if (inputName === "number") {
        return "NumberField";
      }
      if (inputName === "boolean") {
        return "radio";
      }
      if (inputName === "text") {
        return "TextField";
      }
      if (inputName === "multiselect") {
        return "Multiselect";
      }
      return inputName;
    },

    handleRangeUpdate(field, value) {
      const f = field;
      const newVal = [];
      if (Object.keys(f.value).length === 0) {
        // if object empty create emty array
        f.value = [];
      }
      let pushed = false;
      f.value.forEach((val) => {
        if (val.index === value.index && value.check) {
          pushed = true;
        }
        if (val.check) {
          newVal.push(val);
        }
      });
      if (!pushed && value.check) {
        newVal.push(value);
      }

      f.value = newVal;

      if (Object.keys(f.value).length === 0 && f.isRequired) {
        f.invalid = true;
      }
      return f;
    },
  },
};
</script>

<template>
  <main class="c-main">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="form-group product-search mr-3">
              Поиск Класс(ы)..
              <v-select
                label="title"
                :filterable="false"
                :options="products"
                v-model="selected_product"
                @search="debouncedSearch"
              >
                <template slot="no-options">
                  Пожалуйста, выполните поиск класс(ы)..
                </template>
                <template slot="open-indicator">
                  <img
                    src="@/assets/icons/search.svg"
                    alt="search icon"
                    style="width: 20px; height: 20px"
                  />
                </template>
              </v-select>
            </div>
            <template v-if="selected_product">
              <CombinationForm
                @formClear="clearFormState"
                :properties="properties"
                :selected_product="selected_product"
                :product_title="selected_product.title"
                :product_code="selected_product.code"
              />
            </template>
            <template v-if="!selected_product">
              <EmptyArea />
            </template>
            <hr />
            <div class="d-flex">
              <div class="form-group col-2">
                <input type="text" class="form-control" placeholder="Код" v-model="code"/>
              </div>
              <div class="form-group mr-3">
                <button class="btn btn-success" @click="searchWithFilter()">Фильтр</button>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table-striped table">
                <thead>
                  <tr>
                    <th class="p-3">№</th>
                    <th class="p-3">Название</th>
                    <th class="p-3">Код</th>
                    <th class="p-3">Новый код</th>
                    <th class="p-3">Код фармы</th>
                    <th class="p-3">Код значения фармы</th>
                    <th class="p-3">Стат код</th>
                    <th class="p-3">Код значения стат</th>
                    <th class="p-3">Код шаффоф</th>
                    <th class="p-3">Код значения шаффоф</th>
                    <th class="p-3">ИКПУ кодов</th>
                    <th class="p-3">ТН ВЭД кодов</th>
                    <th class="p-3">Названия (RU)</th>
                    <th class="p-3">Названия (UZ)</th>
                    <th class="p-3">Названия (EN)</th>
                    <th class="p-3">Единица измерения</th>
                    <th class="p-3">Дата</th>
                    <th class="p-3 text-center">Действие</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in combinations" :key="index">
                    <td class="p-3">{{ index + 1 }}</td>
                    <td class="flexible p-3">{{ item.product.title }}</td>
                    <td class="flexible p-3">{{ item.code }}</td>
                    <td class="flexible p-3">{{ item.new_code }}</td>
                    <td class="flexible p-3">{{ item.farm_code }}</td>
                    <td class="flexible p-3">{{ item.farm_value_code }}</td>
                    <td class="flexible p-3">{{ item.stat_code }}</td>
                    <td class="flexible p-3">{{ item.stat_value_code }}</td>
                    <td class="flexible p-3">{{ item.shaffof_code }}</td>
                    <td class="flexible p-3">{{ item.shaffof_value_code }}</td>
                    <td class="flexible p-3">{{ item.mxik_code }}</td>
                    <td class="flexible p-3">{{ item.tnvd_code }}</td>
                    <td class="flexible p-3">{{ item.name }}</td>
                    <td class="flexible p-3">{{ item.name_uz }}</td>
                    <td class="flexible p-3">{{ item.name_en }}</td>
                    <td class="flexible p-3">{{ item.unit_name }}</td>
                    <td class="flexible p-3">
                      {{ $moment(item.created_at).format("DD-MM-YYYY") }}
                    </td>
                    <td class="flexible actions">
                      <button
                        @click="() => deleteCombination(item.id)"
                        class="btn btn-danger"
                      >
                        Удалить
                      </button>
                      <!-- <router-link
                        class="btn"
                        :to="{
                          name: 'combination-detail',
                          params: { id: item.id },
                        }"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.42012 12.7132C2.28394 12.4975 2.21584 12.3897 2.17772 12.2234C2.14909 12.0985 2.14909 11.9015 2.17772 11.7766C2.21584 11.6103 2.28394 11.5025 2.42012 11.2868C3.54553 9.50484 6.8954 5 12.0004 5C17.1054 5 20.4553 9.50484 21.5807 11.2868C21.7169 11.5025 21.785 11.6103 21.8231 11.7766C21.8517 11.9015 21.8517 12.0985 21.8231 12.2234C21.785 12.3897 21.7169 12.4975 21.5807 12.7132C20.4553 14.4952 17.1054 19 12.0004 19C6.8954 19 3.54553 14.4952 2.42012 12.7132Z"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M12.0004 15C13.6573 15 15.0004 13.6569 15.0004 12C15.0004 10.3431 13.6573 9 12.0004 9C10.3435 9 9.0004 10.3431 9.0004 12C9.0004 13.6569 10.3435 15 12.0004 15Z"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </router-link> -->
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="row d-flex justify-content-end">
              <paginate
                :page-count="pagination.count"
                :page-range="3"
                :margin-pages="2"
                :click-handler="getCurrentPage"
                :prev-text="'<'"
                :next-text="'>'"
                :container-class="'pagination'"
                :page-class="'page-item'"
                :page-link-class="'page-link-item'"
                :prev-class="'prev-pagination'"
                :prev-link-class="'prev-link-pagination'"
                :next-class="'next-pagination'"
                :next-link-class="'next-link-pagination'"
              ></paginate>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { DELETE, GET, POST } from "@/shared/api";
import { DEBOUNCE } from "@/_helpers/debounce";
import EmptyArea from "@/views/combinationv2/components/EmptyArea.vue";
import CombinationForm from "@/views/combinationv2/components/CombinationForm.vue";

export default {
  components: { EmptyArea, CombinationForm },
  data() {
    return {
      products: [],
      properties: [],
      values: [],
      selected_product: null,
      selected_property: null,
      selected_value: null,
      debouncedSearch: null,
      combinations: [],
      totalCount: 0,
      pagination: {
        count: 0,
        perpage: 10,
      },
      code: ""
    };
  },
  created() {
    this.debouncedSearch = DEBOUNCE(this.handleProductSearch, 500);
  },
  mounted() {
    this.getCombinations();
  },
  watch: {
    selected_product(newVal) {
      if (newVal) {
        this.getProperties({ mode: "fields" }, this.selected_product.id);
      } else {
        this.values = [];
        this.properties = [];
        this.selected_value = null;
        this.selected_property = null;
      }
    },
    selected_property(newVal) {
      if (newVal) {
        this.getValues({ mode: "values" }, this.selected_property.id);
      } else {
        this.values = [];
        this.selected_value = null;
      }
    },
  },
  methods: {
    getCurrentPage(pageNumber) {
      this.pagination.page = pageNumber;
      this.getCombinations();
    },
    getProducts(params = {}) {
      return GET(params, "/productSearch", this, false, false).then(
        (response) => {
          this.products = response;
        }
      );
    },
    getProperties(params = {}, id) {
      GET(params, `/product/query/${id}`, this, false).then((response) => {
        this.properties = response;
      });
    },
    getValues(params = {}, id) {
      GET(params, `/product/query/${id}`, this, false).then((response) => {
        this.values = response;
      });
    },
    getCombinations(params = { ...this.pagination }) {
      GET(params, "/combination", this, false).then((response) => {
        this.combinations = response.data;
        this.totalCount = response.total;
        this.pagination.count = Math.ceil(
          response.total / this.pagination.perpage
        );
      });
    },
    deleteCombination(id) {
      DELETE(id, "/combination/", this).then((response) => {
        this.getCombinations();
      });
    },
    clearFormState() {
      this.products = [];
      this.properties = [];
      this.values = [];
      this.selected_value = null;
      this.selected_property = null;
      this.selected_product = null;
      this.getCombinations();
    },
    async handleProductSearch(search, loading) {
      try {
        loading(true);
        if (!search) return;
        await this.getProducts({ search, with: "category" });
      } finally {
        loading(false);
      }
    },
    searchWithFilter() {
      console.log(this.code)
      if(this.code.length > 0){
        GET({}, `combination?count=0&perpage=10&search=${this.code}`, this, false).then(response => {
          this.combinations = response.data;
          this.totalCount = response.total;
          this.pagination.count = Math.ceil(
            response.total / this.pagination.perpage
          );
        });
      }
    },
  },
};
</script>

<style scoped>
.search-wrapper {
  flex-wrap: wrap;
}

.code:disabled {
  background: transparent;
}

.flexible {
  min-width: 200px;
}

.actions {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.text-center {
  text-align: center;
}
</style>
